module.exports = __webpack_public_path__ + "static/media/Medical_Mask.43e23889.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Medical_Mask.png
// module id = 1233
// module chunks = 0